export class DeviceSettings {
  static ZoneActivityDisabled = 'zone_activity_disabled';
}
